"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.creator = undefined;

var _merge4 = require("lodash/merge");

var _merge5 = _interopRequireDefault(_merge4);

var _union = require("lodash/union");

var _union2 = _interopRequireDefault(_union);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
// For saved for later success just update status to saved and dispatch event in under review compoent to fire call to get new active
//
var creator = exports.creator = function creator() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var arrays = {},
        creator = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.FETCH_FEATURED_CREATORS_SUCCESS:
            arrays = {
                replace: [],
                union: ["keys"]
            };

            if (action.response.keys.length > 0) {
                creator = { featured_creators: action.response };
            } else {
                creator = state;
            }
            if (state.featured_creators) {
                if (state.featured_creators.keys.length > 0) {
                    creator.featured_creators.keys.forEach(function (creatorId) {
                        nextState = mergeEntity("creator", creatorId, state.featured_creators, creator.featured_creators, arrays);
                    });
                    var clonedState = Object.assign({}, state);
                    clonedState.featured_creators = nextState;
                    nextState = Object.assign({}, state, clonedState);
                } else {
                    nextState = Object.assign({}, state, creator);
                }
            } else {
                nextState = Object.assign({}, state, creator);
            }
            return nextState;
            break;

        case actionTypes.FETCH_CREATOR_SUCCESS:
            nextState = action.response;
            return (0, _merge5.default)({}, state, nextState);
            break;

        case actionTypes.DISABLE_CREATOR_SUCCESS:
            nextState = (0, _merge5.default)({}, state, _defineProperty({}, action.response.user_id, { is_active: "False" }));
            return nextState;
            break;

        case actionTypes.TOGGLE_FEATURE_CREATOR_SUCCESS:
            nextState = (0, _merge5.default)({}, state);
            if (action.status === "add") {
                nextState[action.creator_id].featured = true;
            } else {
                nextState[action.creator_id].featured = false;
            }
            return (0, _merge5.default)({}, state, nextState);
            break;

        case actionTypes.SUSPEND_CREATOR_SUCCESS:
            creator = action.response[action.id];
            creator.is_active = "False";
            creator.creator_info.suspension_reason = action.reason;
            nextState = (0, _merge5.default)({}, state, _defineProperty({}, action.id, action.response[action.id]));
            return nextState;
            break;
        case actionTypes.SAVE_CREATOR_NOTE_SUCCESS:
            nextState = (0, _merge5.default)({}, state);
            if (nextState[action.response.user.id]) {
                nextState[action.response.user.id].creator_info.notes = action.response.user.creator_info.notes;
                if (action.response.user.creator_info.important_note === 0) {
                    nextState[action.response.user.id].creator_info.important_note = false;
                } else {
                    nextState[action.response.user.id].creator_info.important_note = true;
                }
            }
            return (0, _merge5.default)({}, state, nextState);
            break;
        case actionTypes.UNSUSPEND_CREATOR_SUCCESS:
            creator = action.response[action.id];
            creator.is_active = "True";
            nextState = (0, _merge5.default)({}, state, _defineProperty({}, action.id, creator));
            return nextState;
            break;
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};

var mergeEntity = function mergeEntity(type, id, state, newObj) {
    var arrays = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    if (state) {
        arrays.union.forEach(function (a) {
            if (newObj[a] && state[a]) {
                newObj[a] = (0, _union2.default)(state[a], newObj[a]);
            }
        });
        arrays.replace.forEach(function (a) {
            if (newObj[a] && state[a]) {
                state[a] = newObj[a];
            }
        });
        newObj = Object.assign({}, state, newObj);
    }

    return Object.assign({}, state, newObj);
};